module.exports = __webpack_public_path__ + "img/mountains3.399dccb8.png";